import $ from 'jquery';


class ChessHistory {
  constructor(container, options = {}) {
    // Store the original container
    this.container = container;

    // Store callbacks
    this.onClose = options.onClose || (() => { });

    // Create the wrapper inside the provided container
    this.wrapper = $('<div class="chess-history-wrapper"></div>');
    this.container.append(this.wrapper);

    this.moves = [];
    this.moveCount = 0;
    this.isVisible = false;
    this.whitePlayer = 'White';
    this.blackPlayer = 'Black';
    this.init();
  }

  init() {
    // Create the HTML structure inside the wrapper
    this.wrapper.html(`
      <div class="chess-history-container" style="display: none;">
        <div class="chess-history-header">
          <div class="chess-history-title">Played moves</div>
          <div class="header-actions">
            <div class="header-actions__close-btn">
              <svg width="24" height="24" class="icon-close" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z" fill="white"></path>
              </svg>
            </div>
          </div>
        </div>
        <div class="chess-history-moves">
          <div class="chess-history-move">
            <div class="chess-history-move-number">0</div>
            <div class="chess-history-move-content">
              <div class="chess-history-move-item white">
                <span class="chess-history-piece"></span>
                <span class="chess-history-coordinates chess-history-player-name">${this.whitePlayer}</span>
              </div>
              <div class="chess-history-move-item black">
                <span class="chess-history-piece"></span>
                <span class="chess-history-coordinates chess-history-player-name">${this.blackPlayer}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    `);

    // Add event listener for close button
    this.wrapper.find('.header-actions__close-btn').on('click', () => {
      this.close();
      this.onClose();
    });
  }

  show() {
    this.wrapper.find('.chess-history-container').fadeIn(200);
    this.container.addClass('is-history');
    this.wrapper.show();
    this.isVisible = true;
  }

  hide() {
    this.wrapper.find('.chess-history-container').fadeOut(200);
    this.container.removeClass('is-history');
    this.wrapper.hide();
    this.isVisible = false;
  }

  toggle() {
    if (this.isVisible) {
      this.hide();
    } else {
      this.show();
    }
  }

  addMove(move) {
    if (!move || !move.piece || !move.from || !move.to) {
      console.error('Invalid move object:', move);
      return;
    }

    this.moveCount++;
    const moveNumber = Math.ceil(this.moveCount / 2);
    const isWhiteMove = this.moveCount % 2 === 1;

    // Get piece symbol
    const pieceSymbol = this.getPieceSymbol(move.piece);

    // Create move element
    const moveElement = $(`
      <div class="chess-history-move">
        <div class="chess-history-move-number">${moveNumber === 0 ? '' : moveNumber}</div>
        <div class="chess-history-move-content">
          <div class="chess-history-move-item">
            <span class="chess-history-piece">${pieceSymbol}</span>
            <span class="chess-history-coordinates">${move.from} → ${move.to}</span>
          </div>
        </div>
      </div>
    `);

    // If it's a white move, create a new move row
    if (isWhiteMove) {
      this.moves.push(moveElement);
      this.wrapper.find('.chess-history-moves').append(moveElement);
      // Scroll to bottom
      this.wrapper.find('.chess-history-moves').scrollTop(
        this.wrapper.find('.chess-history-moves')[0].scrollHeight
      );
    } else {
      // If it's a black move, add it to the last move row
      const lastMove = this.moves[this.moves.length - 1];
      const blackMoveItem = $(`
        <div class="chess-history-move-item">
          <span class="chess-history-piece">${pieceSymbol}</span>
          <span class="chess-history-coordinates">${move.from} → ${move.to}</span>
        </div>
      `);
      lastMove.find('.chess-history-move-content').append(blackMoveItem);
    }
  }

  getPieceSymbol(piece) {
    const symbols = {
      'p': '♟', 'n': '♞', 'b': '♝', 'r': '♜', 'q': '♛', 'k': '♚',
      'P': '♙', 'N': '♘', 'B': '♗', 'R': '♖', 'Q': '♕', 'K': '♔'
    };
    return symbols[piece] || '';
  }

  clear() {
    this.moves = [];
    this.moveCount = 0;
    // Remove all moves except the first row (player names)
    this.wrapper.find('.chess-history-moves .chess-history-move:not(:first-child)').remove();
  }

  close() {
    this.hide();
  }

  destroy() {
    this.clear();
    this.wrapper.find('.header-actions__close-btn').off('click');
    this.wrapper.remove();
  }

  setWhitePlayer(name) {
    this.whitePlayer = name || 'White';
    this.wrapper.find('.chess-history-move-item.white .chess-history-player-name').text(this.whitePlayer);
  }

  setBlackPlayer(name) {
    this.blackPlayer = name || 'Black';
    this.wrapper.find('.chess-history-move-item.black .chess-history-player-name').text(this.blackPlayer);
  }

  setPlayers(whiteName, blackName) {
    this.setWhitePlayer(whiteName);
    this.setBlackPlayer(blackName);
  }
  setMoves(moves) {
    moves = moves.filter((move, index, self) =>
      index === self.findIndex((t) => t.from === move.from && t.to === move.to)
    );
    this.clear();
    moves.forEach(move => this.addMove(move));
  }
}

export default ChessHistory; 